import script from "./DashboardPaymentsSummaryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPaymentsSummaryTab.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPaymentsSummaryTab.vue?vue&type=style&index=0&id=f9ffa9c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9ffa9c6"]])

export default __exports__